import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import { toLocalDateInputValue, toUtcIso } from "./utils";

export default function MoveToDateDialog({ open, appt, activeDate, onSave, onClose }) {
  const [dateOnly, setDateOnly] = useState(toLocalDateInputValue(activeDate));
  useEffect(() => { if (open) setDateOnly(toLocalDateInputValue(new Date(appt?.startUtc || activeDate))); }, [open, appt, activeDate]);
  if (!appt) return null;
  const handleSave = () => {
    const dt = new Date(appt.startUtc);
    const [y, m, d] = dateOnly.split('-').map(Number);
    const local = new Date(dt);
    local.setFullYear(y, m - 1, d);
    const endLocal = new Date(local.getTime() + (new Date(appt.endUtc).getTime() - dt.getTime()));
    onSave({ id: appt.id, practitionerId: appt.practitionerId, locationId: appt.locationId, startUtc: toUtcIso(local), endUtc: toUtcIso(endLocal), patientName: appt.patientName, notes: appt.notes });
  };
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>Move to date</DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2} mt={1}>
          <TextField size="small" type="date" label="Date" value={dateOnly} onChange={(e) => setDateOnly(e.target.value)} InputLabelProps={{ shrink: true }} />
          <Typography variant="caption" color="text.secondary">Time and practitioner remain the same. Constraints apply.</Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>Move</Button>
      </DialogActions>
    </Dialog>
  );
}
